import SpellDetail from './SpellDetail';

export default SpellDetail;
export { SpellDetail };
